//import React, { useState, useEffect } from 'react';
//import PropTypes from 'prop-types';
//import { apiDefaults, apiFetch, parseJSON } from  '../../api'
//
//const Register = () => {
//  const [credentials, setCredentials] = useState({login: '', password: '', name: '', email: ''})
//    const [isLoading, setIsLoading] = useState(false)
//    const myController = new AbortController();
//
//    const handleInput = e => {
//        const name = e.target.name
//        const value = e.target.value
//        setCredentials(prevState => ({...prevState, [name]: value}))
//    }
//
//    const handleSubmit = () => {
//        fetchContent(myController)
//    }
//    
//    const fetchContent = async(controller) => {
//      setIsLoading(true)
//      const url = new URL(`${apiDefaults.project}/auth/authenticate`, apiDefaults.url)
//
//      const response = await fetch(url, {
//          signal: controller.signal,
//          method: 'post',
//          body: JSON.stringify({
//            ...credentials
//          }),
//          headers: {
//            'Content-Type': 'application/json',
//          }
//      })
//
//      const responseJSON = await response.json()
//      window.sessionStorage.accessToken = responseJSON.data.token
//      setIsLoading(false)
//    }
//
//    useEffect(() => {
//      return () => myController.abort()
//    }, [])
//    
//    return (
//        <>
//            <div>
//                <label>Jméno:
//                    <input type="text" value={credentials.username} name="username" onChange={handleInput}/>
//                </label>
//            </div>
//            <div>
//                <label>Heslo:
//                    <input type="password" value={credentials.password} name="password" onChange={handleInput}/>
//                </label>
//            </div>
//            <div>
//                <label>Email:
//                    <input type="email" value={credentials.email} name="email" onChange={handleInput}/>
//                </label>
//            </div>
//            <div>
//                <label>Jméno:
//                    <input type="text" value={credentials.name} name="name" onChange={handleInput}/>
//                </label>
//            </div>
//            <div>
//                <button onClick={handleSubmit} type="submit">Login</button>
//            </div>
//        </>
//    );
//}
//
//Register.propTypes = {
//};
//
//export default Register;

import React, { useState, useEffect } from 'react'
import useAxios from 'axios-hooks'
import { useTranslation } from 'react-i18next'
import yup from '../../yupLocaleCs'
import { Redirect } from 'react-router-dom'
import { useSnackbar } from 'notistack'

//import { apiUrl } from 'utils/api'
import Logo from '../Logo/Logo'

// material-ui
import { Input, InputLabel, FormHelperText, FormControl, Button, makeStyles, Typography, Grid, Paper, Box, FormGroup, FormControlLabel, Checkbox, FormLabel, CircularProgress, IconButton } from '@material-ui/core'

import ErrorIcon from '@material-ui/icons/Error'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing(1),
  },
  box: {
    maxWidth: '65rem',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  paper: {
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  inputLabel: {
    '&::first-letter': {
      textTransform: 'uppercase',
    }
  },
  formText: {
    whiteSpace: 'pre-line'
  }
}))

const Register = () => {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const [errors, setErrors] = useState(null)
  const [touched, setTouched] = useState({})

  const inputs = [
    { id: 'email', defaultValue: '', type: 'email', validation: yup.string().email().label(t('form.email')).required() },
    { id: 'password',  defaultValue: '',type: 'password', validation: yup.string().label(t('form.password')).required().min(8) },
    { id: 'fullName', defaultValue: '', type: 'text', validation: yup.string().label(t('form.fullName')).required() },
    { id: 'agreement', defaultValue: false, type: 'checkbox', validation: yup.bool().equals([true], t('register.validation.dataProcessingAgreement')).label(t('form.dataProcessingAgreement')).required(), aliasType: 'checkbox' },
  ]

  const inputsValidation = yup.object().shape(inputs.reduce((acc, curr) => {
    const { id, validation } = curr
    acc[id] = validation
    return acc
  }, {}))

  const [formData, setFormData] = useState(inputs.reduce((acc, curr) => {
    const { id, defaultValue } = curr
    acc[id] = defaultValue
    return acc
  }, {}))

  const [{ data: putData, loading: putLoading, error: putError }, executePost] = useAxios(
    {
      url: `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PREFIX}/user/register`,
      method: 'POST',
      withCredentials: true,
    },
    { manual: true }
  )

  const handleSubmit = async () => {
    setTouched(inputs.reduce((acc, curr) => {
      const { id } = curr
      acc[id] = true
      return acc
    }, {}))

    try {
      await inputsValidation.validate(formData, { abortEarly: false })
      setErrors(null)

      executePost({
        data: {
          ...formData,
        },
      })
    } catch (e) {
      setErrors(e)
    } 
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  const handleBlur = (e) => {
    const { name } = e.target
    setTouched((prevState) => ({
      ...prevState,
      [name]: true,
    }))
  }

  const validateForm = async () => {
    try {
      await inputsValidation.validate(formData, { abortEarly: false})
      setErrors(null)
    } catch (e) {
      setErrors(e)
    } 
  }

  const action = key => (
      <>
        <IconButton key="close" aria-label={t('snackbar.dismiss')} color="inherit" onClick={() => { closeSnackbar(key) }}>
          <CloseIcon className={classes.icon} />
        </IconButton>
      </>
  )


  useEffect(() => {
    validateForm()
  }, [formData, i18n.language])

  useEffect(() => {
    console.log(putData)
    putData && enqueueSnackbar(t(putData), { action,  variant: 'success', anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    } })
  }, [putData])
  
  useEffect(() => {
    putError && putError.response && enqueueSnackbar(t(putError.response.data), { action,  variant: 'error', anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    } })
  }, [putError])

  return (
    <>
      <Box className={classes.box}>
        <Grid container justify="center" direction="column" alignItems="center">
          <Grid item xs={12} md={10}>
            <Paper className={classes.paper}>
              <Grid container>
                {!putData && 
                  <>
                <Grid item xs={12} md={6}>
                  <Box m={1}>
                    <Logo style={{width: '200px'}}/>
                    <Typography variant="h6" gutterBottom>{t('register.form.title')}</Typography>
                    <Typography paragraph={true} component="p" className={classes.formText}>{t('register.form.text')}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Grid container>
                      {inputs.map((input) => {
                        const { id, type, validation, placeholder, aliasType = 'text' } = input
                        const label = validation._label || id
                        const required = validation._exclusive.required || false
                        const currentErrors = errors && errors.inner
                            ? errors.inner.filter((error) => error.path === id)
                            : []
                        return (
                          <Grid item xs={12}>
                            <FormControl fullWidth className={classes.formControl} error={touched[id] && currentErrors.length > 0}>
                              {aliasType === 'text' &&
                                <>
                                  <InputLabel required={required} className={classes.inputLabel} htmlFor="component-error">{label}</InputLabel>
                                  <Input
                                    id={id}
                                    name={id}
                                    type={type}
                                    value={formData[id]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder={placeholder}
                                    aria-describedby="component-error-text"
                                  />
                                </>
                              }
                              {aliasType === 'checkbox' &&
                                <>
                                  <FormLabel required={required} className={classes.inputLabel} component="legend">{label}</FormLabel>

                                  <FormControlLabel
                                    control={<Checkbox checked={formData[id]} name={id} 
                                    onChange={(e) => {
                                      const { name, checked } = e.target
                                      setFormData(prevState => ({ 
                                        ...formData, [name]: checked
                                      }))
                                    }}
                                    onBlur={handleBlur}
                                    value={id} />}
                                    label={label}
                                  />
                                </>
                              }
                              <FormHelperText id="component-error-text">
                                {touched[id] && currentErrors.map(error => <Typography variant="subtitle2" className={classes.inputLabel} color="error">{typeof error.message === 'object' ? t(error.message.key, { ...error.message.values }) : t(error.message)}</Typography>)}
                              </FormHelperText>
                            </FormControl>
                          </Grid>
                        )
                      })}
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                        <Button fullWidth variant="contained" color="primary" onClick={handleSubmit} disabled={!!putLoading}>{putLoading ? <>{t('register.form.submiting')}
                          <CircularProgress className={classes.progress} size={10} /> 
                      </> : t('register.form.submit')}</Button>
                </Grid>
              </>
                }
                {/*putData && 
                <Redirect
                  to={{
                    pathname: "/",
                  }}
                />*/}
                {putData && 
                <div style={{whiteSpace: 'pre'}}>
                  <Box m={1}>
                    <Logo style={{width: '200px'}}/>
                    <Typography variant="h6" gutterBottom>{t('register.form.afterSuccessTitle')}</Typography>
                    <Typography paragraph={true} component="p" className={classes.formText}>{t('register.form.afterSuccessMessage', { email: formData.email})}</Typography>
                  
                  </Box>
                </div>
                }
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

Register.propTypes = {}

export default Register

